module.exports = __webpack_public_path__ + "img/shiftFish-logo.a17fd730.png";